import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import defaultValues from '../../constant/defaultValues';

import { FilterPaidMembers, pdfToMember, landingPageStatus, manageContacts } from '../../actions/memberAction';

import AcSimpleTable from "../../components/AcSimpleTable";
import InputField from '../../components/InputField';
import SubHeader from '../../components/SubHeader';

import { useAuth } from '../../AuthProvider';
import { hideLoading, showLoading } from "../../actions/loaderAction";
import Emitter from "../../utils/Emitter";
import { ToastContainer } from "react-toastify";
import { showErrorMessage, showSuccessMessage, buildPath, getPrefix, setAuthHeaders } from '../../utils/common';
import { debounce, isEmpty, size, trim } from 'lodash';
import ToolipsCustom from '../../components/ToolipsCustom';
import errorMessages from "../../constant/errorMessages";
import LargePopupCertificate from '../../components/LargePopupCertificate';
import PaidMemberFilter from "../../components/memberFilter/PaidMemberFilter";
import roles from '@/constant/roles.config';
import { privateRoutePaths } from '@/routes/private.route.config';

import MediumPopup from '../../components/MediumPopup';
import { CKEditor } from "@ckeditor/ckeditor5-react";
import {
    ClassicEditor,
    Essentials,
    Bold,
    Italic,
    Underline,
    FontSize,
    Paragraph,
    List,
    Indent
} from "ckeditor5";
import { publicRoutePaths } from '@/routes/public.routes.config';
import ButtonAdd from '../../components/ButtonAdd';
import axiosInstance from '../../axiosHttp';
import API_URL from '../../constant/api.config';
import { toExcel } from 'to-excel';

function PaidMembers(props) {

    const { admin, COMPANY_DEFAULTS, SERVER_TYPE } = defaultValues;
    const statusList = COMPANY_DEFAULTS.STATUS;
    const { user, isSuperAdmin, isPreKYCUser, isDemoUser, isEndUser, isViewer, isOpUser, isInqUser, isAdmin } = useAuth();

    const [tableKey, setTableKey] = useState(0);
    const [memberList, setMemberList] = useState([]);
    const [offset, setOffset] = useState(admin.OFFSET);
    const [limit, setLimit] = useState(admin.LIMIT);
    const [searchTxt, setSearchTxt] = useState("");
    const [loading, setLoading] = useState(false);
    const [totalRows, settotalRows] = useState(0);
    const [columnName, setColumnName] = useState("custom_order");
    const [sortDirection, setSortDirection] = useState(admin.SORT_DIRECTION);
    const [current_page, setCurrentPage] = useState(1);
    const [nodata, setNoData] = useState(false);

    const [largemodalShow, setLargeModalShow] = useState(false);
    const [pdfUrl, setPdfUrl] = useState("");

    const [searchText, setSearchText] = useState('');
    const [searchFilterObj, setFilterObj] = useState({
        filterBy: "",
        filter_type:"",
        offset: admin.OFFSET,
        limit: admin.LIMIT,
        columnName: "custom_order",
        sortDirection: admin.SORT_DIRECTION,
        filter_val: "",
        plan_id: "",
        start_date: "",
        end_date: "",
        table_search: ""
    });

    const [mediumModalShow, setMediumModalShow] = useState(false);
    const [selectedMemberId, setSelectedMemberId] = useState(null);
    const [contactDetail, setContactDetail] = useState("");
    const [errorContactDetail, setErrorContactDetail] = useState("");
    const [copiedId, setCopiedId] = useState(null);

    // const getPrefix = () => {
    //     if (user && isPreKYCUser) return roles.PRE_KYC.prefix;
    //     if (user && isDemoUser) return roles.DEMO.prefix;
    //     if (user && isEndUser) return roles.END_USER.prefix;
    //     if (user && isViewer) return roles.VIEWER.prefix;
    //     if (user && isOperationUser) return roles.OPERATION_USER.prefix;
    //     return roles.SUPER_ADMIN.prefix;
    // };



    const columns = [
        // {
        //     name: 'Sr No',
        //     selector: (row, idx) => {
        //         return (
        //             <>{offset + (idx + 1)}</>
        //         )
        //     },
        //     width: "5%"
        // },
        {
            name: 'Orex ID',
            selector: row => <div className='text-wrap'>{row.member_unique_number}</div>,
            //width: "10%",
            width: "8%",
            columnName: 'member_unique_number',
            sortable: true
        },
        {
            name: 'Company Name',
            selector: row => <div className='text-wrap'>{row.company_name}</div>,
            width: "19%",
            columnName: 'company_name',
            sortable: true
        },
        {
            name: 'Contact Person',
            selector: row => {
                let first_name = !isEmpty(row.first_name) ? row.first_name : '';
                let last_name = !isEmpty(row.last_name) ? row.last_name : '';
                let salutation = !isEmpty(row.salutation) ? row.salutation : '';
                let full_name = isEmpty(first_name) && isEmpty(last_name) ? ' - ' : salutation + ' ' + first_name + ' ' + last_name
                return <div className='text-wrap text-capitalize'>{full_name}</div>
            },
            width: "10%",
            columnName: 'first_name',
            sortable: true
        },
        {
            name: 'Email',
            selector: row => <div className='text-wrap'>{row.email}</div>,
            width: "18%",
            columnName: 'email',
            sortable: true
        },
        {
            name: 'Country',
            selector: row => <div className='text-wrap'>{row.country_name}</div>,
            width: "9%",
            columnName: "country_name",
            sortable: true
        },
        {
            name: 'Plan Start',
            selector: row => <div className='text-wrap'>{row.plan_from_date}</div>,
            width: "8%",
            columnName: "plan_from_date",
            sortable: false
        },
        {
            name: 'Plan Expired',
            selector: row => <div className='text-wrap'>{row.plan_to_date}</div>,
            width: "8%",
            columnName: "plan_to_date",
            sortable: false
        },
        {
            name: 'Status',
            selector: row => {
                if(row.paidSatus === 0)
                return <div className='text-wrap'> <span className="badge bg-danger">Expired</span></div>
                else
                return <div className='text-wrap'> <span className="badge bg-sucess">Active</span></div>
            },
            width: "5%",
            columnName: "status",
            sortable: false
        },
        {
            name: 'Is Landing',
            selector: row => {
                return (
                    <div className='d-flex'>
                        <div className="text-wrap">
                            <label className="switch">
                                <input
                                    type="checkbox"
                                    checked={!!Number(row.is_landing_page)}
                                    onChange={() => handleLandingPage(row.id, !Number(row.is_landing_page))} disabled={isAdmin}
                                />
                                <span className="slider-switch round"></span>
                            </label>

                        </div>
                        {!!Number(row.is_landing_page) && (
                            <ToolipsCustom subtitle={copiedId === row.id ? "Link Copied!" : "Copy Link"} className="fa fa-link border-0 panle-icon " classNameChild={"data-table-tooltiop"} onClick={() => handleLinkClick(row.id)} ></ToolipsCustom>

                        )}
                    </div>

                )
            },
            width: "6%",
            columnName: "Landing Page",
            sortable: false
        },


        {
            name: 'Actions',
            cell: (row) => (
                <div className="text-wrap panle-action action-btn">
                     <div className='dropdown'>
                        <p className='dropdown-toggle' data-bs-toggle="dropdown" aria-expanded="false">
                        <i className="fa-solid fa-ellipsis"></i>
                        </p>
                        <ul className='dropdown-menu'>
                             {(isSuperAdmin || isOpUser || isInqUser) && 
                             <Link to={`/${getPrefix(user)}${buildPath(privateRoutePaths.UPDATE_COMPANY_PROFILE, { id: row.id + "?paid=" + btoa("Paid") })}`}>
                            <li className='dropdown-item'>
                                
                                Edit
                            </li></Link>
                            }
                            {(isSuperAdmin || isOpUser || isInqUser || isAdmin) &&
                            <Link to={`/${getPrefix(user)}${buildPath(privateRoutePaths.VIEW_COMPANY_PROFILE, { id: row.id + "?paid=" + btoa("Paid") })}`}>
                                <li className='dropdown-item'>
                                    View
                                </li>
                            </Link>
                            }
                            {(isSuperAdmin || isOpUser || isAdmin) && row.plan_id > 0 && row.status === 1 && row.establish_date > 0 && row.badge !== null && row.plan_to_date !== null &&
                            <Link to="#" onClick={(e) => { e.preventDefault(); handlePDFClick(row.id); }}>
                                <li className='dropdown-item'>
                                    Download Certificate
                                </li>
                            </Link>
                            }
                            {(isSuperAdmin || isAdmin) && user.role_slug.slug === "SUP_ADM" || user.role_slug.slug === "ADMIN" &&
                            <Link to={`/${getPrefix(user)}${buildPath(privateRoutePaths.PROFILE_HISTORY, { id: row.id + "?history=" + btoa("LOG") })}`}>
                                <li className='dropdown-item'>
                                    History Log
                                </li>
                            </Link>
                            }
                            {(user.role_slug.slug === "SUP_ADM") &&
                            <Link to="#" onClick={(e) => { e.preventDefault(); handleManageContactModal(row.id, row.additional_contacts) }}>
                                <li className='dropdown-item'>
                                        Manage Contacts
                                </li>
                            </Link>
                            }
                            
                        </ul>
                    </div>
                    {/* {(isSuperAdmin || isOpUser) && <Link to={`/${getPrefix(user)}${buildPath(privateRoutePaths.UPDATE_COMPANY_PROFILE, { id: row.id + "?paid=" + btoa("Paid") })}`}>

                        <ToolipsCustom subtitle="Edit" className="fa-regular fa-pen-to-square icon-pen border-0 panle-icon " classNameChild={"data-table-tooltiop"}></ToolipsCustom>

                    </Link>
                    }
                    {(isSuperAdmin || isOpUser || isInqUser) &&
                        <Link to={`/${getPrefix(user)}${buildPath(privateRoutePaths.VIEW_COMPANY_PROFILE, { id: row.id + "?paid=" + btoa("Paid") })}`}>

                            <ToolipsCustom subtitle="View" className="fa-regular fa-eye icon-eyes border-0 panle-icon" classNameChild={"data-table-tooltiop"}></ToolipsCustom>

                        </Link>

                    }
                    {(isSuperAdmin || isOpUser) && row.plan_id > 0 && row.status === 1 && row.establish_date > 0 && row.badge !== null && row.plan_to_date !== null &&
                        <>
                            <ToolipsCustom
                                subtitle="Download Certificate"
                                className="fa-regular fa-file-pdf border-0 panle-icon "
                                classNameChild={"data-table-tooltiop download-certificate"}
                                onClick={() => handlePDFClick(row.id)}
                            >
                            </ToolipsCustom>
                        </>
                    }

                    {isSuperAdmin && user.role_slug.slug === "SUP_ADM" && <Link to={`/${getPrefix(user)}${buildPath(privateRoutePaths.PROFILE_HISTORY, { id: row.id + "?history=" + btoa("LOG") })}`}>

                        <ToolipsCustom subtitle="History Log" className="fas fa-history icon-plan border-0 panle-icon" classNameChild={"data-table-tooltiop password"}></ToolipsCustom>
                    </Link>
                    } */}

                    {/* {(user.role_slug.slug === "SUP_ADM") && <ToolipsCustom subtitle="Manage Contacts" className="fa fa-address-book icon-address-book border-0 " classNameChild={"data-table-tooltiop"} onClick={() => handleManageContactModal(row.id, row.additional_contacts)}></ToolipsCustom>} */}

                </div>
            ),
            Width: '9%'
        }
    ];

    const styleError = {
        display: "block",
    };

    const handleLinkClick = async (member_id) => {
        try {
            let text = buildPath(publicRoutePaths.LANDING_PAGE, {
                id: member_id
            });
            let baseurl = 'http://localhost:3000';
            if (SERVER_TYPE === 'local') {
                baseurl = baseurl;
            } else if (SERVER_TYPE === 'dev') {
                baseurl = 'https://dev.orextrade.com';
            } else if (SERVER_TYPE === 'uat') {
                baseurl = 'https://uat.orextrade.com';
            } else {
                baseurl = 'https://orextrade.com';
            }

            await navigator.clipboard.writeText(baseurl + text);
            setCopiedId(member_id);
            setTimeout(() => setCopiedId(null), 2000);
        } catch (err) {
            console.error('Failed to copy: ', err);
        }
    }

    const handleSort = async (column, sortDirection) => {
        setColumnName(column.columnName);
        setSortDirection(sortDirection);
        filterPaidMembersData(
            offset,
            limit,
            current_page,
            column.columnName,
            sortDirection,
            searchTxt
        );
    };


    const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

    const capitalizeWords = (str) => str.split(" ").map((word) => capitalize(word)).join(" ");


    const handleManageContactModal = (id, contact_details) => {

        setSelectedMemberId(id);
        setErrorContactDetail("");
        if (contact_details) {
            setContactDetail(contact_details.contact_detail);
        } else {
            setContactDetail("");
        }

        setMediumModalShow(true);

    }

    const validContactDetail = () => {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = contactDetail;

        const trimmedText = tempDiv.textContent.trim();

        if (isEmpty(trimmedText)) {
            setErrorContactDetail(errorMessages.FIELD_REQUIRED)
            return false;
        }
        return true;
    }

    const AddContacts = async () => {

        if (await validContactDetail()) {
            let reqObj = {
                contact_detail: contactDetail
            }
            await props.manageContacts(reqObj, selectedMemberId).then((response) => {
                if (response.status === true) {
                    showSuccessMessage(response.message);
                    setSelectedMemberId(null);
                    setMediumModalShow(false);
                    filterPaidMembersData(admin.OFFSET, admin.LIMIT, 1, "custom_order", admin.SORT_DIRECTION, searchTxt);
                }
            }).catch((err) => {
                console.log("Error ============= ", err);
            });
        }
    }


    const onSearchTextBoxChanged = debounce((e) => {
        setSearchText('');
        let searchVal = e.target.value;
        if (searchVal.length >= 3 || searchVal.length == 0) {
            let sFilter = { ...searchFilterObj };
            sFilter.table_search = searchVal;
            setFilterObj(sFilter);
            setOffset(admin.OFFSET);
            setLimit(admin.LIMIT);
            setColumnName("custom_order");
            setSortDirection(admin.SORT_DIRECTION);
            setSearchTxt(e.target.value);
            setCurrentPage(1);
            setTableKey((prev) => prev + 1);
            setSearchText(searchVal);
            setTimeout(async () => {
                await filterPaidMembersData(admin.OFFSET, admin.LIMIT, 1, "custom_order", admin.SORT_DIRECTION, searchVal);
                // props.hideLoading();
            }, 1500);

        }
    });


    const setPaidMembersFilters = (newState) => {

        newState.table_search = "";
        setLimit(newState.limit);
        setOffset(newState.offset);

        setFilterObj(newState);

        setTableKey((prev) => prev + 1);
    }

    const filterApplyOnPaidMembers = (filterObj) => {
        filterPaidMembersData(admin.OFFSET, admin.LIMIT, current_page, "custom_order", admin.SORT_DIRECTION, searchTxt);

    }

    const filterPaidMembersData = async (ofst = 0, lmt = 10, current_page = 1, columnName = "custom_order", sortDirection = "DESC", searchval = "") => {
        props.showLoading();
        setNoData(false);
        let fObj = { ...searchFilterObj };
        if (fObj !== undefined && fObj !== 0 && fObj !== null && fObj !== "") {
            fObj.offset = ofst;
            fObj.limit = lmt;
            fObj.columnName = columnName;
            fObj.sortDirection = sortDirection;
            fObj.table_search = searchval;

            await props.FilterPaidMembers(fObj).then((response) => {
                if (response) {
                    if (response.status === true) {
                        // console.log("filterMemberData Response of api in members page =========== ", response.data);
                        if (size(response.data) === 0) {
                            setNoData(true);
                        }
                        setMemberList(response.data);
                        settotalRows(response.metadata.total);
                    }
                }
            }).catch((err) => {
                console.log("Error ==== ", err);
            });

        }
        props.hideLoading();
    }


    useEffect(() => {
        async function fetchData() {
            await filterPaidMembersData(admin.OFFSET, admin.LIMIT, current_page, "custom_order", admin.SORT_DIRECTION, searchTxt);

        }
        fetchData();
    }, []);



    useEffect(() => {
        Emitter.on("FILTER_MEMBERS", filterApplyOnPaidMembers);
        Emitter.on("SET_FILTER_MEMBERS", setPaidMembersFilters);
        return () => {
            Emitter.off("FILTER_MEMBERS", filterApplyOnPaidMembers);
        };
    });


    const expandedRowComponent = ({ data }) => {
        const rowStatus = statusList.find(option => option.value === data.status);
        const statusLabel = rowStatus ? rowStatus.label : '';
        return (

            <div style={{ padding: '20px', borderTop: '1px solid #ddd' }}>
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr 1fr',
                    gap: '22px',
                    padding: '12px',
                    border: '1px solid #ddd',
                    borderRadius: '8px'
                }}>
                    <div style={{ wordBreak: 'break-word' }}>
                        <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Name:</strong> {(data.salutation ? data.salutation : '') + `  ` + (data.first_name ? data.first_name : '') + ` ` + (data.last_name ? data.last_name : '')}
                        </div>
                        <div className='text-wrap' style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold', float: 'left', marginRight: '3px' }}>Email: </strong> {data.email || '-'}
                        </div>
                        <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Plan Name:</strong> {(data.plan_name == null) ? "Free" : data.plan_name}
                        </div>
                        <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Established Year:</strong> {data.establish_date || '-'}
                        </div>
                        <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>What You Want With Us:</strong> {data.with_us || '-'}
                        </div>
                        <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Status:</strong> {statusLabel}
                        </div>

                    </div>
                    <div>
                        <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Phone:</strong> {data.phone || '-'}
                        </div>
                        <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Country:</strong> {data.country_name || '-'}
                        </div>
                        <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Company Size:</strong> {data.company_size || '-'}
                        </div>
                        <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Industry: </strong> {data.industry_name ? data.industry_name : "-"}
                        </div>
                        <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Trade Mode: </strong>
                            {(data.shipment_mode) && data.shipment_mode} {(data.shipment_mode) && (data.shipment_mode === 'Manufacturer' || data.shipment_mode === 'Trader') ? '(' + capitalize(data.trade_mode_type) + ')' : ''}
                        </div>
                        {data.status === 4 && <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Reason:</strong> {data.reason || '-'}
                        </div>
                        }

                        <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Website:</strong> {data.website || '-'}
                        </div>

                    </div>
                    <div>
                        <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Mobile:</strong> {data.mobile || '-'}
                        </div>

                        {data.status != 4 && <div style={{ marginBottom: '15px' }}>
                            <strong style={{ fontWeight: 'bold' }}>Designation:</strong> {data.designation || '-'}
                        </div>
                        }
                        <div style={{ marginBottom: '15px' }}>

                            <strong style={{ fontWeight: 'bold' }}>Ports: </strong>

                            {data.ports && data.ports.length > 0 ? (
                                (() => {
                                    const portList = data.ports
                                        .map((val) => {
                                            const portName = capitalizeWords(val.dictionary_ports.name || "");
                                            const portCode = val.dictionary_ports.port_code
                                                ? ` (${capitalizeWords(val.dictionary_ports.port_code)})`
                                                : "";
                                            return portName + portCode;
                                        })
                                        .join(", ");

                                    const words = portList.split(" ");
                                    let limitedWords = words.slice(0, 10).join(" ");
                                    limitedWords = trim(limitedWords, ",");
                                    return words.length > 14 ? `${limitedWords}...` : limitedWords;
                                })()
                            ) : (
                                "-"
                            )}

                            {data.ports.length >= 10 ? (<ToolipsCustom classNameChild={"tooltip-responsive logistic-member"} title={"?"} subtitle={data.ports && data.ports.length > 0 ? (
                                data.ports
                                    .map((val) => {
                                        const portName = capitalizeWords(val.dictionary_ports.name || "");
                                        const portCode = val.dictionary_ports.port_code
                                            ? ` (${capitalizeWords(val.dictionary_ports.port_code)})`
                                            : "";
                                        return portName + portCode;
                                    })
                                    .join(", ")
                            ) : (
                                "-"
                            )}>
                            </ToolipsCustom>) : ""}



                        </div>

                        <div style={{ marginBottom: '15px' }}>


                            <strong style={{ fontWeight: 'bold' }}>Trading Country: </strong>

                            {data.trade_countries && data.trade_countries.length > 0 ? (
                                (() => {
                                    const countries = data.trade_countries
                                        .map((val) => val.country.name)
                                        .join(', ')
                                        .split(' ');
                                    let limited = countries.slice(0, 10).join(' ');
                                    limited = trim(limited, ",")
                                    return countries.length > 10 ? `${limited}...` : limited;
                                })()
                            ) : (
                                '-'
                            )}

                            {data.trade_countries && data.trade_countries.length > 10 ? (<ToolipsCustom classNameChild={"tooltip-responsive logistic-member"} title={"?"} subtitle={data.trade_countries && data.trade_countries.length > 0 ? (
                                data.trade_countries.map((val) => val.country.name).join(', ')
                            ) : (
                                '-'
                            )} >

                            </ToolipsCustom >) : ""}



                        </div>

                    </div>
                </div>
            </div>
        );
    };


    const handlePDFClick = async (data) => {
        props.showLoading();



        await props.pdfToMember(data).then((response) => {
            console.log("response", response);
            if (response.status === true) {

                const pdfUrl = response.data.pdf_url;

                setPdfUrl(pdfUrl);

                setLargeModalShow(true);
                props.hideLoading();


            } else {
                console.log("False", response);
                showErrorMessage("Something went wrong!");
            }


        }).catch((err) => {
            console.log("Error ==== ", err);
            showErrorMessage("Something went wrong!");
        })


    }

    const handleLandingPage = async (id, newStatus) => {
        if (!id) return;

        const data = {
            member_id: id,
            pageStatus: newStatus ? 1 : 0
        };

        try {
            const response = await props.landingPageStatus(data);
            if (response.status === true) {
                showSuccessMessage(response.message);
                // setTimeout(async () => {
                await filterPaidMembersData(admin.OFFSET, admin.LIMIT, 1, "custom_order", admin.SORT_DIRECTION, searchText);
                // }, 1500);

            } else {
                showErrorMessage("Something went wrong!");
            }
        } catch (err) {
            console.log("Error ====", err);
            showErrorMessage("Something went wrong!");
        }
    };

    const handleExport = () => {

        if(isEmpty(memberList)) {
             showErrorMessage("No Data Found");
             return;
        }
        let sFilter = searchFilterObj;
        let start_date = sFilter.start_date ?? '';
        let end_date = sFilter.end_date ?? '';
        let filterBy = sFilter.filterBy ?? '';
        let filter_type = sFilter.filter_type ?? '';
        let plan_id = sFilter.plan_id ?? '';

        const headers = setAuthHeaders();

        axiosInstance
            .get(API_URL + "/export-paid-list", {
                headers,
                params: {
                    start_date,
                    end_date,
                    filterBy,
                    filter_type,
                    plan_id
                }
            })
            .then((response) => {
                var data = response.data.data;
                var headers = response.data.headers;

                const now = new Date();
                const year = now.getFullYear();
                const month = String(now.getMonth() + 1).padStart(2, '0');
                const day = String(now.getDate()).padStart(2, '0');
                const hours = String(now.getHours()).padStart(2, '0');
                const minutes = String(now.getMinutes()).padStart(2, '0');
                const seconds = String(now.getSeconds()).padStart(2, '0');

                const formattedDate = `${year}-${month}-${day}_${hours}_${minutes}_${seconds}`;

                toExcel.exportXLS(headers, data, 'Orex_Members_' + formattedDate);
            })
            .catch((err) => {
                console.log("Error ==== ", err);
            });
    };

 



    return (<>

        <div className='data-table-main logistic-table'>
            <div className="AcSimpleTable">

                <SubHeader layer1="Subscription Management" layer2="Paid Members" layer3="List"
                    pageName="Paid Members"
                    clickable={{
                        layer1: "",
                        layer2: "",
                        layer3: ""
                    }}
                />

                <div className='filter-section'>
                    <PaidMemberFilter />
                </div>
                <div className='card1'>

                    <div className='table-header-name'>
                        <h5 className='table-text py-3'>List</h5>
                        <div className='d-flex justify-content-between align-items-center py-3'>
                            {(isSuperAdmin) && (
                                <ButtonAdd className='export-btn ms-2' type="button" onClick={handleExport}>
                                    <i className="fa-solid fa-upload" style={{ transform: "rotate(180deg)" }}></i> Export
                                </ButtonAdd>
                            )}
                            <label className='mx-3'>Search</label>
                            <InputField
                                type="text"
                                id="filter-text-box"
                                placeholder="Search..."
                                className='w-25'
                                onKeyUp={onSearchTextBoxChanged}
                                autoComplete="off"
                            ></InputField>


                        </div>

                    </div>

                    <div className="table-wrapper">
                        <div className="table-container">
                            {memberList && (
                                <AcSimpleTable
                                    key={tableKey}
                                    data={memberList}
                                    title=""
                                    pagination={true}
                                    paginationPageSize={limit}
                                    columns={columns}
                                    progressPending={loading}
                                    paginationTotalRows={totalRows}
                                    fixedColumnsStart={admin.FIXED_COLUMNS_START}
                                    getData={filterPaidMembersData}
                                    offset={offset}
                                    limit={limit}
                                    columnName={columnName}
                                    sortDirection={sortDirection}
                                    setLimit={setLimit}
                                    setOffset={setOffset}
                                    setColumnName={setColumnName}
                                    setSortDirection={setSortDirection}
                                    setLoading={setLoading}
                                    // noDataComponent={<NoData />}
                                    paginationPerPage={limit}
                                    paginationRowsPerPageOptions={admin.PAGINATE_RANGE}
                                    // className="company-table"
                                    striped
                                    sortServer
                                    onSort={handleSort}
                                    defaultSortAsc={false}
                                    current_page={current_page}
                                    setCurrentPage={setCurrentPage}
                                    expandableRows
                                    expandableRowsComponent={expandedRowComponent}
                                    noData={nodata}
                                    searchTxt={searchTxt}
                                />
                            )}
                        </div>
                    </div>
                </div>


                <LargePopupCertificate
                    LargeModalShow={largemodalShow}
                    setLargeModalShow={setLargeModalShow}
                    pdfUrl={pdfUrl}
                >
                </LargePopupCertificate>

                <MediumPopup
                    mediummodalShow={mediumModalShow}
                    setMediumModalShow={setMediumModalShow}
                    type="submit"
                    onSubmit={AddContacts}
                    okButtonLabel="Add"
                    closeButtonLabel="Cancel"
                    title="Manage Contacts"
                >
                    <CKEditor
                        key={`member_${selectedMemberId}`}
                        editor={ClassicEditor}
                        data={contactDetail || ''}
                        config={{
                            toolbar: {
                                items: ['bold', 'italic', 'underline', 'fontSize', 'bulletedList', 'outdent', 'indent'],
                            },
                            fontSize: {
                                options: [10, 12, 14, 'default', 18, 20, 22, 24, 30],
                                supportAllValues: false,
                            },
                            language: 'en',
                            plugins: [
                                Essentials,
                                Bold,
                                Italic,
                                Underline,
                                FontSize,
                                Paragraph,
                                List,
                                Indent
                            ],
                            licenseKey: "GPL",
                            // licenseKey: "",

                        }}
                        onChange={(event, editor) => {
                            const data = editor.getData();
                            setContactDetail(data);
                        }}
                        onReady={(editor) => {
                            editor.editing.view.change((writer) => {
                                writer.setStyle(
                                    "height",
                                    "150px",
                                    editor.editing.view.document.getRoot()
                                );
                                writer.setStyle(
                                    "width",
                                    "100",
                                    editor.editing.view.document.getRoot()
                                );
                            });
                        }}
                        onBlur={(event, editor) => {
                            const data2 = editor.getData();
                            const tempDiv = document.createElement("div");
                            tempDiv.innerHTML = data2;

                            const trimmedText = tempDiv.textContent.trim();

                            if (isEmpty(trimmedText)) {
                                setErrorContactDetail(errorMessages.FIELD_REQUIRED);
                            } else {
                                setErrorContactDetail("");
                            }
                        }}
                    />
                    {errorContactDetail &&
                        <div className="company-required-content" style={styleError}>
                            {" "}
                            {errorContactDetail}
                        </div>
                    }
                </MediumPopup>

            </div>
            {/* <ToastContainer /> */}
        </div>

    </>)
}

const mapStateToProps = state => {

    return {
        member_list: state.member.pendingMemberlist,
        // authError: state.auth.errorMessages
    }
}
const mapDispatchToProps = dispatch => {
    return {
        showLoading: () => dispatch(showLoading()),
        hideLoading: () => dispatch(hideLoading()),
        FilterPaidMembers: (filterData) => dispatch(FilterPaidMembers(filterData)),
        pdfToMember: (data) => dispatch(pdfToMember(data)),
        landingPageStatus: (data) => dispatch(landingPageStatus(data)),
        manageContacts: (data, member_id) => dispatch(manageContacts(data, member_id))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PaidMembers);
